var _clipPath, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZksync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 400 400",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "ArtboardFrame"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 400,
    width: 400,
    x: 0,
    y: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.550304 0.247601L400.453 0.247601L400.453 400.446L-0.550304 400.446L-0.550304 0.247601Z",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M389.998 194.021L282.202 79.042L282.202 163.247L175.169 247.557L282.202 247.635L282.202 309.001L389.998 194.021Z",
    fill: "#4e529a",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0015 193.979L117.798 308.958L117.798 225.431L224.831 140.443L117.798 140.365L117.798 78.9999L10.0015 193.979Z",
    fill: "#8c8dfc",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZksync);
export default __webpack_public_path__ + "static/media/zksync.2375067c2afdfff74e4ad995975a024b.svg";
export { ForwardRef as ReactComponent };